import { render, staticRenderFns } from "./BrigCard.vue?vue&type=template&id=52d01855&scoped=true&"
import script from "./BrigCard.vue?vue&type=script&lang=js&"
export * from "./BrigCard.vue?vue&type=script&lang=js&"
import style0 from "./BrigCard.vue?vue&type=style&index=0&id=52d01855&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d01855",
  null
  
)

export default component.exports